import React from "react";
import Modal from "../../app/UI/Modal/Modal";
import { connect } from "react-redux";

import { closeModal } from "./modalActions";
import UnassignSIMFromDeviceForm from "../inventory/Devices/UnassignSIMFromDevice"

const actions = { closeModal };

const unassignSIMFromDeviceModal = ({ closeModal }) => {
  return (
    <Modal modalHeader="Assign SIM To Device" onClose={closeModal}>
      <UnassignSIMFromDeviceForm />
    </Modal>
  );
};

export default connect(
  null,
  actions
)(unassignSIMFromDeviceModal);
